// extracted by mini-css-extract-plugin
module.exports = {"line":"StatsOne_line__2jSFh","chart":"StatsOne_chart__abk4i"};